<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Mes demandes</span>
        <h3 class="page-title">{{ $t("days.off.request.title") }}</h3>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col">
        <div
          class="card card-small mb-4 mt-3"
          v-if="loading || !user.connected"
        >
          <div class="card-body">
            <spinner-dot />
          </div>
        </div>
        <template v-else>
          <step-one v-if="step === 1" :user.sync="user" @input="step = 2" />
          <step-two
            v-else-if="step === 2"
            :user.sync="user"
            @input="handleStepTwo"
          />
          <step-three
            v-else-if="step === 3"
            :user.sync="user"
            @input="handleStepThree"
          />
          <!-- <step-four v-else-if="step === 4" :user.sync="user" @input="handleStepFour"/> -->
          <step-five
            v-else-if="step === 5"
            :user.sync="user"
            :request="request"
            @input="handleStepFive"
          ></step-five>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import daysOffType from "../../data/daysOff/daysOffType.js";
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import StepOne from "../../components/daysOffRequest/daysOff/StepOne";
import StepTwo from "../../components/daysOffRequest/daysOff/StepTwo";
import StepThree from "../../components/daysOffRequest/daysOff/StepThree";
// import StepFour from '../../components/daysOffRequest/daysOff/StepFour';
import StepFive from "../../components/daysOffRequest/daysOff/StepFive";
import TimeUtils from "../../utils/TimeUtils";
import moment from "moment-timezone";

export default {
  name: "DaysOffRequest",
  components: {
    StepFive,
    // StepFour,
    StepThree,
    StepTwo,
    StepOne,
    SpinnerDot
  },
  mounted() {
    console.log(this.requests);
  },
  data() {
    return {
      request: {},
      step: 1,
      loading: false,
      daysOffType,
      requests: []
    };
  },
  computed: {
    user() {
      return this.$store.state.user.informations;
    }
  },

  methods: {
    handleStepTwo(answer) {
      if (!answer) {
        this.step = 1;
      } else {
        this.request.urgent = answer.urgent;
        if (answer.urgent) {
          this.request.motifUrgent = answer.motifUrgent;
        }
        this.step = 3;
      }
    },

    getDate(value, date) {
      if (value) {
        if (value == 2) {
          return TimeUtils.getMiddleOfDay(date).valueOf();
        }

        return TimeUtils.getFirstHalfOfDay(date).valueOf();
      }

      return TimeUtils.getEndOfDay(date).valueOf();
    },

    handleStepThree(answer) {
      if (!answer) {
        this.step = 2;
      } else {
        this.request.type = answer.type;
        if (answer.type === this.daysOffType.OTHER.value) {
          this.request.motifOther = answer.motifOther;
        }
        if (answer.semiDay) {
          this.request.dateToHalf = answer.dateRange.toWhichHalf;
          this.request.dateFromHalf = answer.dateRange.fromWhichHalf;
        }
        this.request.dateTo = this.getDate(
          answer.dateRange.toWhichHalf,
          answer.dateRange.to
        );
        this.request.dateFrom = this.getDate(
          answer.dateRange.fromWhichHalf,
          answer.dateRange.from
        );
        this.step = 5;
      }
    },

    handleStepFour(answer) {
      if (!answer) {
        this.step = 3;
      } else {
        if (answer.semiDay) {
          this.request.dateToHalf = answer.dateRange.toHalf;
          this.request.dateFromHalf = answer.dateRange.fromHalf;
        }
        this.request.dateTo = answer.dateRange.toHalf
          ? TimeUtils.getMiddleOfDay(answer.dateRange.to).valueOf()
          : TimeUtils.getEndOfDay(answer.dateRange.to).valueOf();
        this.request.dateFrom = answer.dateRange.fromHalf
          ? TimeUtils.getMiddleOfDay(answer.dateRange.from).valueOf()
          : TimeUtils.getEndOfDay(answer.dateRange.from).valueOf();
        this.step = 5;
      }
    },

    handleStepFive(answer) {
      if (!answer) {
        this.step = 3;
      } else {
        this.loading = true;
        const form = {
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          userReference: this.user.reference,
          type: "DAYS_OFF",
          dates: [{ to: this.request.dateTo, from: this.request.dateFrom }],
          model: {
            urgent: this.request.urgent,
            motifUrgent: this.request.motifUrgent,
            type: this.request.type,
            motifOther: this.request.motifOther
          }
        };
        this.$services.absenceRequest.createOne(form).then(() => {
          this.$miniToastr.success(this.$t("days.off.request.success"));
          this.$router.push("/demandes/historique");
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main-content > .main-content-container.container-fluid {
  min-height: calc(100vh - #{3.75rem + 3.75rem});
  @media screen and (min-width: 320px) and (max-width: 767px) {
    height: 910px;
  }
}
</style>
